export const WEEKS = 'weeks';
export const MONTHS = 'months';
export const YEARS = 'years';